

interface TopbarTab  {
    label: string, 
    url: string
}

export type PosthogKeys = {
    api_host: string, 
    posthog_api_key: string
}

export type TopbarData ={
    left: TopbarTab[], 
    right: TopbarTab[], 
    posthog?: PosthogKeys, 
    pageTitle?: string
}

type TopbarDataDictionary = Record<string, TopbarData>;

const orgSetupData: TopbarDataDictionary =  
{
    // Plotline
    "83cfe0d8-731d-4461-a350-22dd02485bee": {
        left: [], 
        right :[
            {
                label: "Login", 
                url: "https://app.plotline.so/flow"
            }
        ], 
        posthog: {
            api_host: "https://app.posthog.com",
            posthog_api_key: "phc_WokBiEScMdrKh86hcxQgyZc5x97dDh50WD6gwYcqagZ"
        }, 
        pageTitle: "Documentation"

    }, 
    // Glowing
    "9e9eeefd-9cb5-42b9-a55b-f42ed145f5d2": {
        left: [], 
        right :[
            {
                label: "Login", 
                url: "https://app.glowing.io/"
            }
        ]
    }, 
    // Finnoto
    "f2d1b46f-dc95-4311-a357-422548e5b268": {
        left: [], 
        right :[
            {
                label: "Home", 
                url: "https://finnoto.com/"
            }
        ]
    }, 

    //Clueso
    "c7c44004-d4fa-429c-80c2-c3092b5acd5a": {
        left: [], 
        right :[
            {
                label: "Book demo", 
                url: "https://calendly.com/clueso_intro/25min"
            },
            {
                label: "Home", 
                url: "https://web.clueso.io"
            }
        ], 
        posthog: {
            api_host: "https://app.posthog.com",
            posthog_api_key: "phc_K9xtjpstJIE86BCqAq7SLsbsWK31H7YggUQZIf8xf9x"
        }

    }, 

    //FirstHR
    "8e3417ad-705f-4348-8de5-3052adaf56a1": {
        left: [], 
        right :[
            {
                label: "Contact Us", 
                url: "https://firsthr.app/contacts"
            }, 
            {
                label: "Log In", 
                url: "https://panel.firsthr.app/signin"
            }
        ]
    }

}

export const getPageTitle = (orgId: string) => {

    if(orgSetupData[orgId]){
        const pageTitle =  orgSetupData[orgId].pageTitle || "Help Center"
        console.log("pageTitle: ", pageTitle)
        return pageTitle
    }
    else {
        return "Help Center"
    }

}

export default orgSetupData